import { render, staticRenderFns } from "./settlements.vue?vue&type=template&id=207d67ae&scoped=true&"
import script from "./settlements.vue?vue&type=script&lang=js&"
export * from "./settlements.vue?vue&type=script&lang=js&"
import style0 from "./settlements.vue?vue&type=style&index=0&id=207d67ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d67ae",
  null
  
)

export default component.exports